"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepType = void 0;
var StepType;
(function (StepType) {
    StepType["DISCOVER"] = "discover";
    StepType["EVALUATE"] = "evaluate";
    StepType["PREPARE_TO_APPLY"] = "apply";
    StepType["COMMIT"] = "commit";
    StepType["STUDY"] = "study";
    StepType["GET_READY"] = "get_ready";
})(StepType = exports.StepType || (exports.StepType = {}));
